import InfiniteScroll from '@/components/common/infinite-scroll';
import QuestionItem from '@/components/molecules/question-list/question-item';
import ScrollTopStickyButton from '@/components/molecules/scroll-top-sticky-button';
import { SearchQuestionViewModel } from '@/hooks/search/qna/useSearchQuestionViewModel';
import EmptySearchResult from '../empty-search-result';

interface Props {
  viewModel: SearchQuestionViewModel;
}

const QnaSearchResult = ({ viewModel }: Props) => {
  if (!viewModel.searchedQnaData?.pages?.length) {
    return <EmptySearchResult handleClickRequestButton={viewModel.handleClickRequestButton} />;
  }

  return (
    <>
      <InfiniteScroll
        rootMargin={'0px 0px 0px 100px'}
        isLoading={viewModel.isSearchedQnaLoading}
        hasNextPage={viewModel.hasSearchedQnaNextPage}
        fetchNextPage={viewModel.fetchSearchedQnaNextPage}
      >
        {viewModel.searchedQnaData?.pages.map((question) => {
          return (
            <QuestionItem
              isPaidQuestion={false}
              key={question.question.questionPid}
              questionCard={question}
              onClickQuestion={viewModel.onClickQuestion}
            />
          );
        })}
      </InfiniteScroll>
      <ScrollTopStickyButton />
    </>
  );
};

export default QnaSearchResult;
